import React from 'react';

// tslint:disable:max-line-length
export const HomeSupportIcon = () => (
  <svg width="96" height="96" viewBox="0 0 96 96">
    <defs>
      <polygon id="spot_home_96px-a" points="0 45 49 45 49 0 0 0" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path
        fill="#F8F8F8"
        d="M96,47.9986667 C96,74.508 74.5093333,95.9973333 48,95.9973333 C21.4893333,95.9973333 0,74.508 0,47.9986667 C0,21.4893333 21.4893333,0 48,0 C74.5093333,0 96,21.4893333 96,47.9986667"
      />
      <g transform="translate(23 23)">
        <polygon fill="#FA4616" points="17.534 1 14 4.612 14 45 48 45 48 17.664 31.829 1" />
        <polygon fill="#FA633B" points="17.005 0 0 17.996 0 45 35 45 35 17.996 18.354 0" />
        <polygon fill="#373B3C" points="17.005 0 17 .005 34.006 18 50 18 32.997 0" />
        <polygon fill="#FFF" points="25 33 31 33 31 24 25 24" />
        <polygon fill="#FFF" points="16 33 22 33 22 24 16 24" />
        <path
          fill="#FFC72C"
          d="M12,31.9420626 C12,29.7652086 10.2096463,28 7.99948553,28 C5.7903537,28 4,29.7652086 4,31.9420626 L4,42 L12,42 L12,31.9420626 Z"
        />
        <mask id="spot_home_96px-b" fill="#fff">
          <use xlinkHref="#spot_home_96px-a" />
        </mask>
        <polygon fill="#505050" points="2 45 14 45 14 42 2 42" mask="url(#spot_home_96px-b)" />
        <path
          fill="#0A5ACD"
          d="M6.08279076,36.3302459 C6.08279076,36.6160271 5.84981695,36.8490009 5.56403575,36.8490009 C5.27825455,36.8490009 5.04528074,36.6160271 5.04528074,36.3302459 C5.04528074,36.0444647 5.27825455,35.8114909 5.56403575,35.8114909 C5.84981695,35.8114909 6.08279076,36.0444647 6.08279076,36.3302459"
          mask="url(#spot_home_96px-b)"
        />
      </g>
    </g>
  </svg>
);
